export const GET_RECEIPT_PAGE_NUMBER = 'receipt/GET_RECEIPT_PAGE_NUMBER'
export const SET_RECEIPT_PAGE_NUMBER = 'receipt/SET_RECEIPT_PAGE_NUMBER'
export const SET_RECEIPT_LIMIT_PAGE = 'receipt/SET_RECEIPT_LIMIT_PAGE'
export const SET_RECEIPT_FILTER_DATA = 'receipt/SET_RECEIPT_FILTER_DATA'
export const SET_RECEIPT_TICKET_FILTER_DATA = 'receipt/SET_RECEIPT_TICKET_FILTER_DATA'
export const SET_RETAILER_COUNTRY = 'receipt/SET_RETAILER_COUNTRY'
export const SET_RETAILER_NAME = 'receipt/SET_RETAILER_NAME'
export const SET_RETAILER_LIMIT_PAGE = 'receipt/SET_RETAILER_LIMIT_PAGE'
export const SET_RETAILER_PAGE_NUMBER = 'receipt/SET_RETAILER_PAGE_NUMBER'
export const GET_RECEIPT_LIST = 'receipt/GET_RECEIPT_LIST'
export const GET_RECEIPT_LIST_SUCCESS = 'receipt/GET_RECEIPT_LIST_SUCCESS'
export const GET_RECEIPT_LIST_FAIL = 'receipt/GET_RECEIPT_LIST_FAIL'

export const SET_RECEIPT_CASE_RESOLVED = 'receipt/SET_RECEIPT_CASE_RESOLVED'
export const SET_RECEIPT_CASE_RESOLVED_SUCCESS = 'receipt/SET_RECEIPT_CASE_RESOLVED_SUCCESS'
export const SET_RECEIPT_CASE_RESOLVED_FAIL = 'receipt/SET_RECEIPT_CASE_RESOLVED_FAIL'
export const SET_RECEIPT_CASE_REJECTED = 'receipt/SET_RECEIPT_CASE_REJECTED'
export const SET_RECEIPT_CASE_REJECTED_SUCCESS = 'receipt/SET_RECEIPT_CASE_REJECTED_SUCCESS'
export const SET_RECEIPT_CASE_REJECTED_FAIL = 'receipt/SET_RECEIPT_CASE_REJECTED_FAIL'

export const SET_RECEIPT_MAPPING = 'receipt/SET_RECEIPT_MAPPING'
export const SET_RECEIPT_MAPPING_SUCCESS = 'receipt/SET_RECEIPT_MAPPING_SUCCESS'
export const SET_RECEIPT_MAPPING_FAIL = 'receipt/SET_RECEIPT_MAPPING_FAIL'
export const SET_RECEIPT_MAPPING_REJECTED = 'receipt/SET_RECEIPT_MAPPING_REJECTED'
export const SET_RECEIPT_MAPPING_REJECTED_SUCCESS = 'receipt/SET_RECEIPT_MAPPING_REJECTED_SUCCESS'
export const SET_RECEIPT_MAPPING_REJECTED_FAIL = 'receipt/SET_RECEIPT_MAPPING_REJECTED_FAIL'

export const SET_RECEIPT_MAPPING_TEMPLATE = 'receipt/SET_RECEIPT_MAPPING_TEMPLATE'
export const SET_RECEIPT_MAPPING_TEMPLATE_SUCCESS = 'receipt/SET_RECEIPT_MAPPING_TEMPLATE_SUCCESS'
export const SET_RECEIPT_MAPPING_TEMPLATE_FAIL = 'receipt/SET_RECEIPT_MAPPING_TEMPLATE_FAIL'

export const getReceiptPageNumber = payload => ({
  type: GET_RECEIPT_PAGE_NUMBER,
  payload
})

export const setReceiptPageNumber = payload => ({
  type: SET_RECEIPT_PAGE_NUMBER,
  payload
})

export const setReceiptLimitPage = payload => ({
  type: SET_RECEIPT_LIMIT_PAGE,
  payload
})

export const setReceiptFilterData = payload => ({
  type: SET_RECEIPT_FILTER_DATA,
  payload
})
export const setReceiptTicketFilterData = payload => ({
  type: SET_RECEIPT_TICKET_FILTER_DATA,
  payload
})

export const setRetailerCountry = payload => ({
  type: SET_RETAILER_COUNTRY,
  payload
})

export const setRetailerName = payload => ({
  type: SET_RETAILER_NAME,
  payload
})

export const setRetailerLimitPage = payload => ({
  type: SET_RETAILER_LIMIT_PAGE,
  payload
})

export const setRetailerPageNumber = payload => ({
  type: SET_RETAILER_PAGE_NUMBER,
  payload
})

export const getReceiptList = payload => ({
  type: GET_RECEIPT_LIST,
  payload
})

export const getReceiptListSuccess = payload => ({
  type: GET_RECEIPT_LIST_SUCCESS,
  payload
})

export const getReceiptListFail = payload => ({
  type: GET_RECEIPT_LIST_FAIL,
  payload
})

export const setReceiptCaseResolved = payload => ({
  type: SET_RECEIPT_CASE_RESOLVED,
  payload
})

export const setReceiptCaseResolvedSuccess = payload => ({
  type: SET_RECEIPT_CASE_RESOLVED_SUCCESS,
  payload
})

export const setReceiptCaseResolvedFail = payload => ({
  type: SET_RECEIPT_CASE_RESOLVED_FAIL,
  payload
})

export const setReceiptCaseRejected = payload => ({
  type: SET_RECEIPT_CASE_REJECTED,
  payload
})

export const setReceiptCaseRejectedSuccess = payload => ({
  type: SET_RECEIPT_CASE_REJECTED_SUCCESS,
  payload
})

export const setReceiptCaseRejectedFail = payload => ({
  type: SET_RECEIPT_CASE_REJECTED_FAIL,
  payload
})

export const setReceiptMapping = payload => ({
  type: SET_RECEIPT_MAPPING,
  payload
})

export const setReceiptMappingSuccess = payload => ({
  type: SET_RECEIPT_MAPPING_SUCCESS,
  payload
})

export const setReceiptMappingFail = payload => ({
  type: SET_RECEIPT_MAPPING_FAIL,
  payload
})

export const setReceiptMappingRejected = payload => ({
  type: SET_RECEIPT_MAPPING_REJECTED,
  payload
})

export const setReceiptMappingRejectedSuccess = payload => ({
  type: SET_RECEIPT_MAPPING_REJECTED_SUCCESS,
  payload
})

export const setReceiptMappingRejectedFail = payload => ({
  type: SET_RECEIPT_MAPPING_REJECTED_FAIL,
  payload
})

export const setReceiptMappingTemplate = payload => ({
  type: SET_RECEIPT_MAPPING_TEMPLATE,
  payload
})

export const setReceiptMappingTemplateSuccess = payload => ({
  type: SET_RECEIPT_MAPPING_TEMPLATE_SUCCESS,
  payload
})

export const setReceiptMappingTemplateFail = payload => ({
  type: SET_RECEIPT_MAPPING_TEMPLATE_FAIL,
  payload
})
